module.exports = __webpack_public_path__ + "img/2019homepark-5.77e0b5a6.jpeg";